
      if (import.meta.env.VITE_ENVIRONMENT === 'production') {
        const gtagScript = document.createElement('script');
        gtagScript.async = true;
        gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=G-36XF3TEQW9';
        document.head.appendChild(gtagScript);

        gtagScript.onload = () => {
          window.dataLayer = window.dataLayer || [];
          function gtag() {
            dataLayer.push(arguments);
          }
          gtag('js', new Date());
          gtag('config', 'G-36XF3TEQW9');
        };
      }
    